import './header.js'
import './accordion.js'
import './office-availability.js'
import './carousel.js'
import './archive-filter.js'
import './truncate-text.js'
import './flip-card.js'
import './fixed-image.js'
import './animated-menu.js'
import './header-search.js'
import './search-filter.js'
import './infinite-scroll.js'
import './services-accordion.js'
import './practice-header.js'
import './newsletter-form.js'
import './contact-form.js'
import './hubspot-forms.js'
import './office-carousel.js'
import './gated-form.js'
import './you-are-in.js'

// Your main.js code here
console.log('main.js loaded')

// Function to dynamically load the Lottie Player for standard <lottie-player> (JSON files)
const loadDynamicImports = async () => {
  try {
    // Check if there are any Lottie elements on the page
    const lottiePlayer = document.querySelector('lottie-player')
    if (lottiePlayer) {
      const module = await import('@lottiefiles/lottie-player')
      // Module is loaded and ready to use
      console.log('Standard Lottie player module loaded successfully')
      return module
    }
  } catch (error) {
    console.error('Error loading Lottie Player:', error)
  }
}

// Initialize Lottie Player when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', loadDynamicImports)
} else {
  loadDynamicImports()
}
